// extracted by mini-css-extract-plugin
export default {"c2Box":"C2_c2Box__1Rf82","c2CarouselImg":"C2_c2CarouselImg__u6woC","c2CarouselBox":"C2_c2CarouselBox__FD6Pz","textBox":"C2_textBox__D13c5"};